import React from "react";

interface ChevronIconProps {
    className?: string;
    color?: string;
    direction?: "left" | "right";
    size?: "sm" | "md";
}

export const ChevronIcon = ({
    className = "",
    color = "currentColor",
    direction = "right",
    size = "sm",
}: ChevronIconProps) => {
    const sizeClasses = {
        sm: "w-4 h-4",   // ~16x16px
        md: "w-5 h-5",   // ~20x20px
    };

    return (
        <div className="icon chevron-icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className={`${sizeClasses[size]} ${className}`}
                aria-hidden="true"
            >
                <path d={direction === "right" ? "M9.5 5.5 16 12l-6.5 6.5" : "M14.5 5.5 8 12l6.5 6.5"} />
            </svg>
        </div>
    );
};

export default ChevronIcon;
